import { useParams } from 'react-router-dom';
import { TokenScreen, type TokenInfo } from '@bala/ui';
import { api } from '../api';
import { useAuth } from '../auth';

/**
 * Invitation et réinitialisation de mot de passe.
 *
 * L'écran vit dans `@bala/ui` ; cette page fournit ce qui lui manque : le jeton
 * lu dans l'URL, le public attendu, et les trois appels réseau. Le contrôle du
 * public est fait des deux côtés — à la lecture du lien et à son acceptation —
 * parce qu'un jeton peut changer de main entre les deux.
 */
function useTokenClient() {
  const auth = useAuth();
  return {
    lookup: (token: string) =>
      api.get<TokenInfo>(`/auth/token/${encodeURIComponent(token)}`, { cache: false }),
    accept: (token: string, password: string) =>
      api.post<{ audienceType: string }>(
        '/auth/accept',
        { token, password },
        { queueOffline: false },
      ),
    openSession: async () => {
      // Le serveur a posé le cookie de session : il ne reste qu'à charger l'identité.
      await auth.refresh();
    },
  };
}

function Screen() {
  const { token = '' } = useParams();
  const client = useTokenClient();
  return <TokenScreen token={token} audience="user" client={client} />;
}

export function InvitationPage() {
  return <Screen />;
}

export function PasswordResetPage() {
  return <Screen />;
}
